import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";


export const useCreateStandaloneDealMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dealApi.createStandaloneDeal,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.all });

      const contactUuids = [
        variables.associatedContactUuid,
        ...(variables.associatedContactReferences ?? []),
      ].filter(Boolean) as string[];
      const companyUuids = [
        variables.associatedCompanyUuid,
        ...(variables.associatedCompanyReferences ?? []),
      ].filter(Boolean) as string[];

      contactUuids.forEach((contactUuid) =>
        queryClient.invalidateQueries({
          queryKey: dealQueryKeys.byContact(contactUuid),
        }),
      );
      companyUuids.forEach((companyUuid) =>
        queryClient.invalidateQueries({
          queryKey: dealQueryKeys.byCompany(companyUuid),
        }),
      );
    },
  });
};
